import * as React from "react";
import ReactCalendar from "react-calendar/dist/entry.nostyle";
import PropTypes from "prop-types";
import find from "lodash-es/find";
import moment from "moment";

import { getTileClassName } from "./get-tile-class-name";
import { DateType, Moment } from "../../model/utils";

export const shortDays = ["do", "lu", "ma", "me", "gi", "ve", "sa"];

const Calendar = ({ date, setDate, isDateRange, allowedDateRanges }) => {
  const [previousValue] = React.useState(date);

  const wrappedSetDate = React.useCallback(
    newValue => {
      if (
        isDateRange &&
        moment(newValue[0]).isSame(moment(newValue[1]), "day") &&
        previousValue
      ) {
        setDate(previousValue);
      } else {
        setDate(newValue);
      }
    },
    [setDate, isDateRange, previousValue]
  );

  const isTileDisabled = ({ date }) => {
    const today = moment();
    const momentDate = moment(date);
    return (
      !allowedDateRanges ||
      momentDate.isBefore(today, "day") ||
      find(
        allowedDateRanges,
        ([start, end]) =>
          start.isSameOrBefore(momentDate, "day") &&
          momentDate.isSameOrBefore(end, "day")
      ) === undefined
    );
  };

  return (
    <ReactCalendar
      onChange={wrappedSetDate}
      value={date}
      prevLabel=""
      nextLabel=""
      showNeighboringMonth={false}
      formatShortWeekday={(_, weekDay) => shortDays[weekDay.getDay()]}
      tileClassName={getTileClassName}
      selectRange={isDateRange}
      tileDisabled={isTileDisabled}
    />
  );
};

Calendar.propTypes = {
  date: DateType,
  setDate: PropTypes.func.isRequired,
  isDateRange: PropTypes.bool.isRequired,
  allowedDateRanges: PropTypes.arrayOf(
    PropTypes.arrayOf(PropTypes.instanceOf(Moment)).isRequired
  )
};

export default Calendar;
